/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS202: Simplify dynamic range loops
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
//= require search/widget_factories

window.ProductApprovalWidgets = {
  stateWidget() {
    const orderdedState = ['Draft', 'Under Review', 'Submitted', 'Rejected', 'Approved', 'Expired'];

    return instantsearch.widgets.refinementList({
      container: '#state',
      attribute: 'state_text',
      sortBy(a, b) { if (orderdedState.indexOf(a.name) < orderdedState.indexOf(b.name)) { return -1; } else { return 1; } },
      limit: 5,
      searchable: false,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      templates: {
        item(hit) {
          return "<label class='ais-RefinementList-label'>" +
          "<input type='checkbox' class='ais-RefinementList-checkbox' value='" + hit.value + "' " + (hit.isRefined ? 'checked' : '') + ">" +
          "<span class='status-label " + hit.value.toLowerCase().replace(/ /g,"_") + "'>" + hit.value + "</span>" +
          "</input><span class='ais-RefinementList-count'>" + hit.count + "</span>" +
          "</label>";
        }
      }
    });
  },

  initAsyncHitsLoadingBreakdown() {
    return instantsearch.widgets.asyncHitsLoadingBreakdown = options => ({
      // For every new search: query or facet update
      render(options) {
        const nbPages = Math.ceil(options.results.nbHits / 1000);
        if (options.results.nbHits > 0) {
          const timestamp = performance.now();
          const onSearchResponse = function(response) {
            ProductApprovalsBreakdown.loadData(response, timestamp);
          };

          for (let i = 0, end = nbPages, asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
            if (i === 0) {
              ProductApprovalsBreakdown.clearData(timestamp, nbPages);
            }
            options.helper.searchOnce({
              hitsPerPage: 1000,
              attributesToHighlight: [],
              attributesToRetrieve: [
                'categories.lvl0',
                'state',
                'supplier.name'
              ],
              page: i
            }).then(onSearchResponse);
          }
        } else {
          ProductApprovalsBreakdown.loadNoData();
        }
      }
    });
  }
};